var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wi-portal",attrs:{"id":"app"}},[_c('div',{staticClass:"view-wrapper"},[_c('login-container')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }